import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// const firebaseConfig = {
//   apiKey: "xxxxxx",
//   authDomain: "xxxx",
//   projectId: "bharatiyavidyarthi-c9ee7",
//   storageBucket: "xxxx",
//   messagingSenderId: "xxxx",
//   appId: "xxxx",
//   measurementId: "xxxx"
// };
const firebaseConfig = {
  apiKey: "AIzaSyDg-Vj8oOMVmWjq61XmsWVMtg-bbeLqkFg",
  authDomain: "bharatiyavidyarthi-c9ee7.firebaseapp.com",
  projectId: "bharatiyavidyarthi-c9ee7",
  storageBucket: "bharatiyavidyarthi-c9ee7.appspot.com",
  messagingSenderId: "433139696758",
  appId: "1:433139696758:web:6ba4c8f36fae46e86c8b57"
};

const app=initializeApp(firebaseConfig);
const auth = getAuth(app);
export { auth };

